// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/javascripts/libraries_and_infrequently_changed.js
var JSML = window.JSML;
// modified with global simulating transforms: pre, post
// MAGIC_DESPROCKET_END
// ADW: First element should be the tag you want to create, which can also include
// a class or an id, Slim/jquery style (i.e. div.class or span#id). Like Slim, if
// you just specify the class or id, it assumes you want a div.
//
// What. the. fuck.
var JSML = {

    transform: function(tree) {
        var name = tree.shift();
        var id_string,
        classes_string;

        name = name.replace(/#([^.]+)/,
        function(whole_match, interesting_bit) {
            id_string = interesting_bit;
            return '';
        });

        name = name.replace(/\.([^#]+)/,
        function(whole_match, interesting_bit) {
            classes_string = interesting_bit.replace('.', ' ', 'g');
            return '';
        });

        if (name === '') {
            name = 'div';
        }

        var el = document.createElement(name);

        if (id_string) {
            el.setAttribute('id', id_string);
        }

        if (classes_string) {
            el.setAttribute('class', classes_string);
            el.setAttribute('className', classes_string);
            // for ie
        }

        for (var i in tree) {
            if (tree.hasOwnProperty(i)) {
                var node = tree[i];
                if (node.constructor === String) {
                    el.appendChild(document.createTextNode(node));
                }
                else if (node.constructor === Array) {
                    el.appendChild(JSML.transform(node));
                }
                else {
                    for (var key in node) {
                        var value = node[key];
                        if (value.constructor === Function) {
                            el[key] = value;
                        }
                        else if (value.constructor === String) {
                            el.setAttribute(key, node[key]);
                            //ie wierdness
                            if (key === 'class') {
                                el.setAttribute('className', node[key]);
                            }
                            else if (key === 'style' && el.style && el.style.setAttribute) {
                                el.style.setAttribute('cssText', node[key]);
                            }
                        }
                        else {
                            var combined_val = '';
                            for (var prop in value) {
                                combined_val += prop + ': ' + value[prop] + '; ';
                            }
                            el.setAttribute(key, combined_val);
                        }
                    }
                }
            }
        }

        return el;
    }

};
// MAGIC_DESPROCKET_START
window.JSML = JSML;
// MAGIC_DESPROCKET_END
